/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import { indexer } from "../../../utils/utils";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import { usePushNotification } from "../../../api/notification/use-push-notification";
import Table from "../../../components/ui/Table/Table";
import { convertDateToDateTime } from "../../../helper/formatDate/formate-date";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);

        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "구분",
      cell: (info) => {
        const createdAt = info.row.original.createdAt;
        const scheduleTime = info.row.original.scheduleTime;

        return (
          <div className="w-14 m-auto">
            {scheduleTime ? "예약 발송" : "즉시 발송"}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row.isSent, {
      header: "발송 상태",
      cell: (info) => {
        const isSent = info.row.original.isSent;
        const isCanceled = info.row.original.isCanceled;
        const createdAt = info.row.original.createdAt;
        const scheduleTime = info.row.original.scheduleTime;
        const createdAtDateTime = dayjs(createdAt).unix();
        const scheduleTimeDateTime = dayjs(scheduleTime).unix();
        const rendered = () => {
          switch (createdAtDateTime !== scheduleTimeDateTime) {
            case true:
              switch (isSent) {
                case true:
                  return "발송 완료";
                case false:
                  switch (isCanceled) {
                    case true:
                      return "발송취소 완료";
                    case false:
                      return (
                        <span className="text-[#e80000]">발송 예약 대기</span>
                      );
                    default:
                      break;
                  }
                  break;
                default:
                  break;
              }
              break;
            case false:
              return "발송 완료";

            default:
              break;
          }
        };
        return <div>{rendered()}</div>;
      },
    }),

    columnHelper.accessor((row) => row.shippingNo, {
      header: "발송번호",
      cell: (info) => {
        const val = info.getValue();
        return <div className="w-40 m-auto">{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.title, {
      header: "제목",
      cell: (info) => {
        const val = info.getValue();
        const title = val?.length > 20 ? val?.substring(0, 20) + "..." : val;

        return <div>{val ? title : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row.createdAt, {
      header: "등록일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{date ? date : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "발송 예정 일시",
      cell: (info) => {
        const scheduleTimeVal = info.getValue()?.scheduleTime;
        const isSent = info.getValue()?.isSent;
        const isCanceled = info.getValue()?.isCanceled;
        const date = convertDateToDateTime(scheduleTimeVal);
        return (
          <div>
            {scheduleTimeVal !== null ? (
              isSent ? (
                date
              ) : (
                <span
                  className={`${
                    isCanceled ? "line-through" : "text-[#e80000] "
                  }`}
                >
                  {date}
                </span>
              )
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.display({
      header: "관리",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`${id}`)}
      className="w-12 p-[3px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function NotificationTable(props) {
  const { filter, sort, onSort } = props;
  const { isEmpty, getDataTableProps } = usePushNotification(filter, sort);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;

  const sorts = [
    { id: "CREATED_AT_DESC", name: "최신순" },
    { id: "CREATED_AT_ASC", name: "등록일시순" },
    { id: "SCHEDULE_TIME_DESC", name: "발송 예정 일시순" },
  ];

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center">
          등록된 상품이 없습니다.
          <br /> ONEDAY Mall에 상품을 등록하실 경우, '+ 상품등록'을
          진행해주세요.
        </div>
      ) : (
        <>
          <Table
            hasSave={false}
            sorts={sorts}
            onSort={onSort}
            columns={columns(currentPage, pageSize, totalData)}
            hasPageSizeFilter={false}
            width="w-[8rem]"
            isRightAlignmentSort={true}
            dropdownWidth="w-[8rem]"
            {...getDataTableProps()}
          />
        </>
      )}
    </>
  );
}
